class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }
  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }
  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: "0px 0px -100px 0px" }
    );
    this.observer.observe(this);
  }
  loadRecommendations(productId) {
    fetch(
      `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("product-recommendations");

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (
          !this.querySelector("slideshow-component") &&
          this.classList.contains("complementary-products")
        ) {
          this.remove();
        }

        if (html.querySelector(".grid__item")) {
          this.classList.add("product-recommendations--loaded");
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document
          .querySelectorAll("[data-wishlist-toggle]")
          .forEach((button) => {
            const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
            const productHandle = button.dataset.productHandle;
            if (wishlist.includes(productHandle)) {
              button.classList.add("in-wishlist", "remove");
              button.setAttribute("aria-label", "remove to wishlist");
            }
          });

        const allCards = document.querySelectorAll(".card-product");

        allCards.forEach((product) => {
          const slider = product.querySelector(".card__slider-container");

          product.addEventListener("click", (e) => {
            // Handle color swatches
            const colorOption = e.target.closest(
              ".card-product__color-option:not(.disabled)"
            );
            // Color Swatches Function
            if (colorOption) {
              e.preventDefault();
              handleColorSwatch(colorOption, product);
            }
          });
        });

        // Initialize recommendation slider after content is loaded
        const recommendationSlider = this.querySelector(
          ".recommendation-slider"
        );
        if (recommendationSlider && window.initRecommendationSlider) {
          // Use setTimeout to ensure DOM is fully updated
          setTimeout(() => {
            window.initRecommendationSlider(recommendationSlider);
          }, 0);
        }

        // Expand/show the section wrapper when recommendations are loaded
        const sectionWrapper = this.closest(".recommendations");
        if (sectionWrapper && this.innerHTML.trim().length > 0) {
          // Check if there's actual content (not just empty)
          const hasContent =
            this.querySelector(".recommendation-section") ||
            this.querySelector(".recommendation-slider") ||
            this.querySelector(".product-card-slide");

          if (hasContent) {
            // Remove hidden class first to allow measurement
            sectionWrapper.classList.remove("recommendations-hidden");

            // Use requestAnimationFrame for smooth transition
            requestAnimationFrame(() => {
              // Get the natural height while element is visible
              sectionWrapper.style.height = "auto";
              const naturalHeight = sectionWrapper.scrollHeight;
              sectionWrapper.style.height = "0";
              sectionWrapper.style.overflow = "hidden";

              // Force reflow
              void sectionWrapper.offsetHeight;

              // Animate to full height
              requestAnimationFrame(() => {
                sectionWrapper.style.height = `${naturalHeight}px`;
                sectionWrapper.style.opacity = "1";

                // After transition, set to auto and add visible class
                setTimeout(() => {
                  sectionWrapper.style.height = "auto";
                  sectionWrapper.style.overflow = "visible";
                  sectionWrapper.classList.add("recommendations-visible");
                }, 300);
              });
            });
          }
        }
      });
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Expose initRecommendationSlider globally so it can be called from ProductRecommendations class
window.initRecommendationSlider = function initRecommendationSlider(slider) {
    if (!slider || slider.dataset.sliderInited) return;
    slider.dataset.sliderInited = "1";

    const container =
      slider.closest(".featured-container") || slider.parentElement;
    const items = slider.querySelectorAll(".product-card-slide");
    if (!items.length) return;

    const getGap = () => parseInt(window.getComputedStyle(slider).gap) || 10;
    const getCardW = () => items[0].offsetWidth + getGap();

    let current = 0;
    let max = Math.max(0, slider.scrollWidth - container.clientWidth);
    let isDragging = false;
    let startX = 0;
    let startPos = 0;
    const clickThreshold = 5;

    // Prevent image dragging across browsers
    slider.querySelectorAll("img").forEach((img) => {
      img.setAttribute("draggable", "false");
      img.addEventListener("dragstart", (e) => e.preventDefault());
    });

    slider.addEventListener("mousedown", startDrag);
    slider.addEventListener("touchstart", startDrag, { passive: false });

    function startDrag(e) {
      if (e.type === "mousedown" && e.button !== 0) return;
    
    // Don't start drag if touching a quick add button
    const quickAddBtn = e.target.closest(".quick-add-btn");
    if (quickAddBtn) {
      return; // Let the quick add button handle the event
    }
    
      isDragging = false;
      startX = e.touches ? e.touches[0].clientX : e.clientX;
      startPos = current;

      document.addEventListener("mousemove", onDrag, { passive: false });
      document.addEventListener("touchmove", onDrag, { passive: false });
      document.addEventListener("mouseup", endDrag);
      document.addEventListener("touchend", endDrag);
      e.preventDefault();
    }

    function onDrag(e) {
      const x = e.touches ? e.touches[0].clientX : e.clientX;
      const diff = startX - x;

      if (!isDragging && Math.abs(diff) < clickThreshold) return;

      if (!isDragging) {
        isDragging = true;
        slider.classList.add("dragging");
        document.body.classList.add("slider-dragging");
        slider.style.transition = "none";
      }

      current = Math.max(Math.min(startPos - diff, 0), -max);
      slider.style.transform = `translateX(${current}px)`;
      e.preventDefault();
    }

    function endDrag(e) {
      document.removeEventListener("mousemove", onDrag);
      document.removeEventListener("touchmove", onDrag);
      document.removeEventListener("mouseup", endDrag);
      document.removeEventListener("touchend", endDrag);

      document.body.classList.remove("slider-dragging");

      if (!isDragging) {
        const a = e.target.closest("a");
        if (a) a.click();
        return;
      }

      isDragging = false;
      slider.classList.remove("dragging");

      // 🔑 Snap calculation
      const step = getCardW();
      let idx = Math.round(Math.abs(current) / step);
      let newPos = -(idx * step);

      // if near the end, clamp to exact max
      if (Math.abs(current) > max - step / 2) {
        newPos = -max;
      }

      slideTo(newPos);
    }

    function slideTo(p) {
      current = p;
      slider.style.transition = "transform 0.3s ease";
      slider.style.transform = `translateX(${p}px)`;
    }

    // Keep bounds correct on resize/content changes
    const ro = new ResizeObserver(() => {
      max = Math.max(0, slider.scrollWidth - container.clientWidth);
      current = Math.max(Math.min(current, 0), -max);
      slideTo(current);
    });
    ro.observe(container);
};

(() => {
  // 1) If recommendations were server-rendered (no AJAX), init on DOM ready
  document.addEventListener("DOMContentLoaded", () => {
    document
      .querySelectorAll(".recommendation-slider")
      .forEach(window.initRecommendationSlider);
  });

  // 2) If using AJAX via <product-recommendations>, init after it swaps in HTML
  document
    .querySelectorAll(
      "product-recommendations.recommendations, product-recommendations.recommended-slider-wrapper"
    )
    .forEach((wrap) => {
      const mo = new MutationObserver(() => {
        const slider = wrap.querySelector(".recommendation-slider");
        if (slider) window.initRecommendationSlider(slider);
      });
      mo.observe(wrap, { childList: true, subtree: true });
    });
})();
